import { render, staticRenderFns } from "./CustomerUserList.vue?vue&type=template&id=958910f8"
import script from "./CustomerUserList.vue?vue&type=script&lang=js"
export * from "./CustomerUserList.vue?vue&type=script&lang=js"
import style0 from "./CustomerUserList.vue?vue&type=style&index=0&id=958910f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports